<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="offerAgreementGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <v-tooltip
            v-if="
              $userCheckAccess({
                abilities: 'edit_user_agreement',
              })
            "
            :disabled="offerAgreementLast.published == 1 ? true : false"
            bottom
            color="#2C2C2C"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <BaseButton
                  @click="
                    $router.push({
                      name: 'settingOfferAgreementCreate',
                    })
                  "
                  :text="localStorage.translations.pages['setting-offer_agreement'].buttons.create"
                >
                  <template v-slot:icon>
                    <svg
                      width="14"
                      height="16"
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.5718 12.1551H1.11155C0.498619 12.1551 0 11.6758 0 11.0868V1.06832C0 0.479223 0.498619 0 1.11155 0H5.92829V2.49274C5.92829 3.08183 6.42691 3.56106 7.03985 3.56106H9.63348V9.5551C8.45685 9.63001 7.5266 10.571 7.5266 11.7208C7.5266 11.8696 7.54216 12.0148 7.5718 12.1551ZM7.03985 5.00922H2.59363C2.38883 5.00922 2.22311 5.16849 2.22311 5.36533C2.22311 5.56216 2.38883 5.72143 2.59363 5.72143H7.03985C7.24465 5.72143 7.41037 5.56216 7.41037 5.36533C7.41037 5.16849 7.24465 5.00922 7.03985 5.00922ZM7.03985 6.43364H2.59363C2.38883 6.43364 2.22311 6.59292 2.22311 6.78975C2.22311 6.98658 2.38883 7.14585 2.59363 7.14585H7.03985C7.24465 7.14585 7.41037 6.98658 7.41037 6.78975C7.41037 6.59292 7.24465 6.43364 7.03985 6.43364ZM7.03985 7.85806H2.59363C2.38883 7.85806 2.22311 8.01734 2.22311 8.21417C2.22311 8.411 2.38883 8.57028 2.59363 8.57028H7.03985C7.24465 8.57028 7.41037 8.411 7.41037 8.21417C7.41037 8.01734 7.24465 7.85806 7.03985 7.85806ZM5.55778 9.28249H2.59363C2.38883 9.28249 2.22311 9.44176 2.22311 9.63859C2.22311 9.83542 2.38883 9.9947 2.59363 9.9947H5.55778C5.76257 9.9947 5.92829 9.83542 5.92829 9.63859C5.92829 9.44176 5.76257 9.28249 5.55778 9.28249Z"
                        fill="#F2F2F2"
                      />
                      <path d="M8.42993 12.8107H14V13.6081H8.42993V12.8107Z" fill="#F2F2F2" />
                      <path
                        d="M11.6128 10.4187L11.6128 16.0001H10.8171L10.8171 10.4187L11.6128 10.4187Z"
                        fill="#F2F2F2"
                      />
                      <path
                        d="M7.03995 2.84869H9.41648L6.66943 0.208496V2.49258C6.66943 2.68906 6.83552 2.84869 7.03995 2.84869Z"
                        fill="#F2F2F2"
                      />
                    </svg>
                  </template>
                </BaseButton>
              </div>
            </template>
            <span>{{
              localStorage.translations.pages['setting-offer_agreement'].tooltips
                .user_agreement_not_published
            }}</span>
          </v-tooltip>
        </template>
        <div class="table_grid">
          <div
            class="table_grid__new"
          >
            <OfferAgreementTable
              v-if="offerAgreementGrid.filter((i) => i.published == 1 && i.is_active == 1).length"
              :items="offerAgreementGrid.filter((i) => i.published == 1 && i.is_active == 1)"
              :type="'publish'"
            />
            <OfferAgreementTable
              v-if="offerAgreementGrid.filter((i) => i.published == 0).length"
              :items="offerAgreementGrid.filter((i) => i.published == 0)"
              :type="'new'"
            />
            <Plug
              v-if="
                offerAgreementGrid.filter((i) => i.published == 1 && i.is_active == 1).length == false &&
                offerAgreementGrid.filter((i) => i.published == 0).length == false
              "
            />
          </div>
          <div
            class="history"
          >
            <p class="f18">
              {{ localStorage.translations.pages['setting-offer_agreement'].tables.history }}
            </p>
            <OfferAgreementTable
             v-if="offerAgreementGrid.filter((i) => i.published == 1 && i.is_active == 0).length"
              :items="
                $route.query.page == 1
                  ? offerAgreementGrid.filter((i) => i.published == 1 && i.is_active == 0)
                  : offerAgreementGrid
              "
              :type="'history'"
            />
           <Plug v-else />
          </div>
        </div>
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import OfferAgreementTable from 'components/setting/offerAgreement/OfferAgreementTable'
import Plug from 'components/Plug.vue'

export default {
  name: 'OfferAgreement',
  components: {
    Plug,
    OfferAgreementTable,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
    this.onOfferAgreementLast()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('offerAgreement', ['offerAgreementGrid', 'pageData', 'offerAgreementLast']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('offerAgreement', ['onOfferAgreementGrid', 'onOfferAgreementLast']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onOfferAgreementGrid(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.table_grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 50px;

  &__new {
    @media #{map-get($display-breakpoints, 'xl-only')} {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
      justify-content: space-between;
      column-gap: 24px;
    }
  }
}
</style>